import { NgModule } from '@angular/core';
import { FiEditNamesMatComponent } from './fi-edit-names-mat.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { FiAppTextSharedModule } from '@fi-shared/app-text';

@NgModule({
    imports: [CommonModule, FormsModule, MatFormFieldModule, MatInputModule, FiAppTextSharedModule],
    declarations: [FiEditNamesMatComponent],
    exports: [FiEditNamesMatComponent],
})
export class FiEditNamesMatModule {}
